import { Attachment } from '../../../shared/components/attachments/attachment-service/models/attachment-model';

export class Message {
  content = '';
  body = '';
  fromAddress: string;
  fromName: string;
  fromUserId: number;
  id: number;
  sentOn: Date;
  threadId: string;
  toAddress: string;
  toName: string;
  type = 'Email';
  attachments: Array<Attachment> = [];
  source = 'ApplicantMessages';

  createReply(): Message {
    return Object.assign(
      new Message(),
      {
        type: this.type,
        fromAddress: this.toAddress,
        fromName: this.toName,
        threadId: this.threadId,
        source: this.source
      });
  }
}
